import * as Yup from 'yup'

// Email validation schema for EmailReportModal
export const emailValidationSchema = Yup.object().shape({
    emailAddresses: Yup.string()
        .required('Please enter at least one email address')
        .test('email-format', 'Please enter valid email addresses separated by semicolons', function(value) {
            if (!value || !value.trim()) return false
            
            const emailList = value.split(';').map(email => email.trim()).filter(email => email)
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            
            return emailList.length > 0 && emailList.every(email => emailRegex.test(email))
        })
})

// Export default
export default emailValidationSchema